//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import foretell from "~/mixins/foretell.js";
import API from "~/api/api";
import orderCreatable from "~/mixins/orderCreateable.js";
import aos from "~/mixins/aos.js";
import schemaHelpers from "~/mixins/schema-helpers.js";

export default {
  mixins: [foretell, orderCreatable, aos, schemaHelpers],
  layout: "default",
  data() {
    return {
      // companyName: "",
      is_auth_modal: false,
      headerLocalFormType: "signup",
      showLearnMorePopup: false,
      showSticky: false,
      pageInfo: {},
      loading: false,
      selectedEntity: "",
    };
  },
  jsonld() {
    if (!this.loading || !this.error) {
      return {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": "https://www.legalnature.com/business",
        },
        headline: this.pageInfo.fields.meta_information.table.title,
        description: this.pageInfo.fields.meta_information.table.description,
        author: this.schemaAuthor,
        logo: this.schemaLogo,
      };
    }
  },
  async asyncData({ app, query, params, redirect, error }) {
    try {
      let pageSlug;
      if (params.entity_type && params.entity_type != "llc") {
        pageSlug = params.entity_type + "-new-new";
      } else if (params.entity_type && params.entity_type === "llc") {
        pageSlug = "llc-new-new";
      } else {
        pageSlug = "general-new-new";
      }
      let pageInfo = await API.butterPages.get(app.$axios, pageSlug, {
        preview: query.preview ? 1 : 0,
      });
      return {
        pageInfo,
        loading: false,
        error: false,
      };
    } catch (e) {
      console.error(e);
      error({ message: "Error fetching data..." });

      return {
        loading: false,
      };
    }
  },

  head() {
    if (!this.loading || !this.error) {
      return {
        title: this.pageInfo.fields.meta_information.table.title,
        meta: [
          {
            name: "description",
            content: this.pageInfo.fields.meta_information.table.description,
          },
          {
            name: "keyword",
            content: this.pageInfo.fields.meta_information.table.keyword,
          },
        ],
      };
    } else {
      return {
        title: "Business Formation | LegalNature",
        meta: [
          { name: "description", content: "Business Formation" },
          { name: "keyword", content: "Business Formation" },
        ],
      };
    }
  },

  mounted() {
    if (process.client) {
      this.createOrLoadUserWithForetellEvent("lnd", {
        lander_test: "bp:business-entity",
      });

      this.$store
        .$db()
        .model("profile")
        .getProfile();
      window.addEventListener(
        "scroll",
        () => {
          if (this.$mq.resize) {
            if (this.$mq.above(this.$mv.md)) {
              this.showSticky = window.pageYOffset > 500;
            } else {
              this.showSticky = window.pageYOffset > 400;
            }
          }
        },
        { passive: true }
      );
    }
  },

  methods: {
    handleCardClick(e) {
      e.stopPropagation();
    },
    handleBackgroundClick(e) {
      this.showLearnMorePopup = false;
    },
    showAuthModal() {
      if (this.isProfileLoaded && this.isAuthenticated)
        this.createFormationOrder({
          entityType: "LLC",
          // companyName: this.companyName,
        });
      else this.is_auth_modal = true;
    },
    hideAuthModal() {
      this.is_auth_modal = false;
    },
    authSuccess() {
      this.createFormationOrder({
        entityType: this.entityType,
        // companyName: this.companyName,
      });
    },
  },

  computed: {
    entityType() {
      switch (this.$route.params.entity_type) {
        case "llc":
          return "LLC";
          break;
        case "s-corporation":
          return "S Corp";
          break;
        case "c-corporation":
          return "C Corp";
          break;
        case "nonprofit":
          return "Nonprofit";
          break;
      }
      return "";
    },
    isProfileLoaded() {
      return this.loadRequest ? this.loadRequest.isLoaded : false;
    },
    loadRequest() {
      return this.$store
        .$db()
        .model("requests")
        .find("profile");
    },
    profile() {
      return this.$store
        .$db()
        .model("profile")
        .query()
        .first();
    },
    isAuthenticated() {
      if (this.isProfileLoaded && this.profile) return this.profile.registered;
    },
    platform() {
      return {
        headline: "Introducing your business command center",
        description:
          "You'll get a secure personalized dashboard that stores all of your legal forms. Edit, download, and print your documents at any time from any device.",
      };
    },
    getStarted() {
      return {
        headline: "Ready to get started?",
        text:
          "Create your business in minutes. Let us handle your filing so you can focus on running your business.",
      };
    },
    featuresWithIcon() {
      let data = {
        headline: "The benefits of forming an LLC",
        description: "",
        feature: [
          {
            table: {
              title: "Liability Protection",
              description:
                "Owners and employees are shielded from becoming personal responsible for the company's debts and other obligations.",
              icon:
                '<svg width="50" height="56" viewBox="0 0 50 56" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.26" d="M48.4629 15.6234L43.2657 34.8163C42.5431 37.4846 41.2157 39.9813 39.2036 41.8862C33.2509 47.5215 28.1442 49.6343 18.7642 51.0247C11.837 44.7679 8.47988 40.3992 5.98883 33.3209C4.98974 30.482 5.05084 27.3935 5.83942 24.4814L10.9268 5.69423C11.1734 4.7835 12.0239 4.16564 12.9673 4.21183L30.7356 5.08181C31.4626 5.11741 32.1724 5.31076 32.8154 5.64839L47.469 13.3425C48.2944 13.7759 48.7069 14.7225 48.4629 15.6234Z" fill="#C7E6FA"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M39.7644 26.8217V6.96163C39.7644 6.02804 39.1185 5.21865 38.2082 5.01149L22.0387 1.3318C21.3307 1.17068 20.5961 1.1657 19.886 1.3172L2.49285 5.02797C1.56987 5.22488 0.910156 6.0402 0.910156 6.98395V26.4233C0.910156 29.4439 1.66017 32.4485 3.37059 34.9381C7.62692 41.1335 12.0122 44.4929 20.3373 48.761C29.0315 45.0167 33.4116 41.6689 37.6863 34.7051C39.1342 32.3464 39.7644 29.5894 39.7644 26.8217ZM29.6761 17.2406C30.0985 16.8226 30.7812 16.8226 31.2037 17.2406C31.629 17.6615 31.629 18.3461 31.2037 18.767L19.487 30.3607C19.0973 30.7463 18.4699 30.7463 18.0802 30.3607L11.026 23.3806C10.6007 22.9597 10.6007 22.275 11.026 21.8542C11.4485 21.4362 12.1312 21.4362 12.5536 21.8542L18.7836 28.0188L29.6761 17.2406Z" fill="white"/>\n</svg>\n',
            },
          },
          {
            table: {
              title: "Simplified Tax Accounting",
              description:
                "Unlike corporations, which file a separate tax return, LLC owners can simply pay all of their income taxes on their personal tax returns.",
              icon:
                '<svg width="65" height="52" viewBox="0 0 65 52" fill="none" xmlns="http://www.w3.org/2000/svg">\n<rect x="1.79297" y="32.276" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect y="37.6553" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="3.58398" y="43.0344" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="1.79297" y="48.4137" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="35.8633" y="26.8966" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="37.6543" y="32.276" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="35.8633" y="37.6553" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="35.8633" y="43.0344" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<rect x="37.6543" y="48.4137" width="26.8966" height="3.58621" rx="1" fill="white"/>\n<circle cx="51" cy="12" r="12" fill="white" fill-opacity="0.2"/>\n<circle cx="15.2392" cy="17.0345" r="11.6552" fill="white"/>\n<circle cx="17" cy="18" r="12" fill="white" fill-opacity="0.2"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M49.3095 23.3104C55.7465 23.3104 60.9647 18.0922 60.9647 11.6552C60.9647 5.2182 55.7465 0 49.3095 0C42.8725 0 37.6543 5.2182 37.6543 11.6552C37.6543 18.0922 42.8725 23.3104 49.3095 23.3104ZM48.7572 9.41387C48.7572 10.6285 47.9595 11.6552 46.7808 11.6552C45.6139 11.6552 44.8281 10.641 44.8281 9.43891V9.41387C44.8281 8.19926 45.6259 7.17249 46.8046 7.17249C47.9714 7.17249 48.7572 8.18674 48.7572 9.38882V9.41387ZM46.8522 16.0378H45.6735L51.7696 7.27266H52.9483L46.8522 16.0378ZM53.7937 13.8966C53.7937 15.1112 52.9959 16.138 51.8172 16.138C50.6504 16.138 49.8645 15.1238 49.8645 13.9217V13.8966C49.8645 12.682 50.6623 11.6552 51.841 11.6552C53.0078 11.6552 53.7937 12.6695 53.7937 13.8716V13.8966ZM45.8878 9.41387C45.8878 10.1276 46.2688 10.6911 46.8046 10.6911C47.3642 10.6911 47.6976 10.1151 47.6976 9.43891V9.41387C47.6976 8.71265 47.3166 8.13665 46.7808 8.13665C46.2212 8.13665 45.8878 8.71265 45.8878 9.38882V9.41387ZM50.9242 13.8966C50.9242 14.6104 51.3052 15.1738 51.841 15.1738C52.4006 15.1738 52.734 14.5978 52.734 13.9217V13.8966C52.734 13.1954 52.353 12.6194 51.8172 12.6194C51.2576 12.6194 50.9242 13.1954 50.9242 13.8716V13.8966Z" fill="white"/>\n<path d="M14.9193 21.5173H15.7924V20.4804C17.067 20.3652 17.9301 19.6006 17.9301 18.4589V18.438C17.9301 17.3173 17.2778 16.6784 15.7523 16.2804V14.2904C16.224 14.3951 16.6756 14.6151 17.1172 14.9607L17.6792 13.9762C17.1272 13.5468 16.5251 13.2744 15.7924 13.1802V12.5518H14.9193V13.1592C13.6648 13.264 12.8117 14.0286 12.8117 15.1597V15.1807C12.8117 16.3537 13.4942 16.9298 14.9594 17.3278V19.3806C14.3071 19.2759 13.7651 18.9617 13.1931 18.4799L12.5508 19.433C13.2332 19.9986 14.0462 20.3652 14.9193 20.4699V21.5173ZM14.9594 16.0605C14.1867 15.8196 13.996 15.5368 13.996 15.1074V15.0864C13.996 14.6256 14.3272 14.2695 14.9594 14.2171V16.0605ZM15.7523 19.4225V17.5268C16.5351 17.7677 16.7458 18.0505 16.7458 18.5113V18.5323C16.7458 19.035 16.3845 19.3702 15.7523 19.4225Z" fill="#30BAF3"/>\n</svg>\n',
            },
          },
          {
            table: {
              title: "Easy, Flexible, and Affordable",
              description:
                "With fewer state requirements, LLCs are by far the easiest and most affordable business type to own and operate.",
              icon:
                '<svg width="56" height="52" viewBox="0 0 56 52" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M56 49.6739C56 50.9583 43.4639 52 28 52C12.5361 52 0 50.9583 0 49.6739C0 48.3895 12.5361 47.3478 28 47.3478C43.4639 47.3478 56 48.3895 56 49.6739Z" fill="#8BACC1"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5024 27.1064L2.43279 21.4771C0.785575 20.328 0.606445 18.238 2.01102 16.8308L7.14232 11.6896C8.55661 10.2726 11.2807 9.45162 13.2393 9.85844L17.9074 10.8281C14.0437 16.1527 11.4357 22.0041 10.5024 27.1064ZM40.3999 32.8449L41.4891 38.1087C41.9002 40.0955 41.0897 42.8682 39.6755 44.2851L34.5442 49.4263C33.1198 50.8534 31.0428 50.6385 29.8825 48.9688L24.0464 40.5708C29.0815 39.5783 34.8862 36.8833 40.3999 32.8449Z" fill="white"/>\n<path fill-rule="evenodd" clip-rule="evenodd" d="M49.1413 1.72745C45.4773 -1.94611 33.8575 0.0478166 24.3725 9.5576C14.8874 19.0674 11.7622 31.852 15.4286 35.5279C19.095 39.2039 30.9661 36.325 41.3315 26.5608C51.6969 16.7966 52.8053 5.401 49.1413 1.72745ZM36.1664 19.4343C38.7438 19.4343 40.8331 17.3515 40.8331 14.7821C40.8331 12.2127 38.7438 10.1299 36.1664 10.1299C33.5891 10.1299 31.4998 12.2127 31.4998 14.7821C31.4998 17.3515 33.5891 19.4343 36.1664 19.4343Z" fill="white"/>\n</svg>\n',
            },
          },
        ],
      };
      return data;
    },
  },
};
